<template>
  <div class="data-table-container table-responsive">
    <table class="table table-hover table-condensed">
      <thead>
        <tr>
          <!-- <th v-for="(key,index) in colsWithAlias" :key="index"
            @click.stop="sortBy(key.ColumnName)"
            :class="{ active: sortKey == key.ColumnName }">
            {{ key.ColumnAlias | capitalize }}
            <span class="arrow" :class="sortOrders[key.ColumnName] > 0 ? 'asc' : 'dsc'">
            </span>
          </th> -->
          <th v-for="(key,index) in colsWithAlias"
            @click="sortBy(key.ColumnName)"
            :class="{ active: sortKey == key.ColumnName }" class="text-align-center border-right" :key="index">
            {{ key.ColumnAlias | capitalize }}
            <span class="arrow" :class="checkSortable(key.ColumnName) == true ? (sortOrders[key.ColumnName] > 0 ? 'asc' : 'dsc') : 'none'">
            </span>
          </th>
        </tr>
      </thead>
      <tbody v-if="currDashboardTabSelection === 1">
        <tr v-for="entry in filteredData" :key="entry['UserId'] + '-' + entry['CohortId']" :class="{'opacity-point-5': entry['isUnEnrolled']}">
          <td v-for="key in columns" :key="key" class="text-align-center">
            <div v-if="key !== 'ProgressPercent' && key !== 'DiscussionPosts' && key !== 'ChallengesTaken' && key !== 'LastLoginTS' && key !== 'Email' && key !== 'WebProgressPercent' && key !== 'MobileProgressPercent'">
              {{ entry[key] }}
            </div>
            <div v-else-if="key === 'Email'">
              <a :href="'mailto:'+entry[key]" target="_top">{{ entry[key] }}</a>
            </div>

            <div v-else-if="key === 'ProgressPercent'">
              <div :class="['stat-value-label', { 'danger': entry[key] === 0 }]">
                <span class="value">{{ entry[key] }}%</span>
              </div>

              <div class="progress margin-auto">
                <div :class="getStatusClasses(getPercent(entry[key], 100))" role="progressbar" :aria-valuenow="entry[key]" aria-valuemin="0" aria-valuemax="100" :style="getStyle(entry[key], 100)">
                  <span class="sr-only">{{ entry[key] }}% Complete (success)</span>
                </div>
              </div>
            </div>

            <div v-else-if="key === 'WebProgressPercent'">
              <div :class="['stat-value-label', { 'danger': entry[key] === 0 }]">
                <span class="value">{{ entry[key] }}%</span>
              </div>

              <div class="progress margin-auto">
                <div :class="getStatusClasses(getPercent(entry[key], 100))" role="progressbar" :aria-valuenow="entry[key]" aria-valuemin="0" aria-valuemax="100" :style="getStyle(entry[key], 100)">
                  <span class="sr-only">{{ entry[key] }}% Complete (success)</span>
                </div>
              </div>
            </div>

            <div v-else-if="key === 'MobileProgressPercent'">
              <div :class="['stat-value-label', { 'danger': entry[key] === 0 }]">
                <span class="value">{{ entry[key] }}%</span>
              </div>

              <div class="progress margin-auto">
                <div :class="getStatusClasses(getPercent(entry[key], 100))" role="progressbar" :aria-valuenow="entry[key]" aria-valuemin="0" aria-valuemax="100" :style="getStyle(entry[key], 100)">
                  <span class="sr-only">{{ entry[key] }}% Complete (success)</span>
                </div>
              </div>
            </div>

            <div v-else-if="key === 'DiscussionPosts'">
              <div :class="['stat-value-label', { 'danger': getPercent(entry[key], entry['TotalReflections']) === 0 }]">
                <span class="value">{{ entry[key] }}</span>/<span class="total">{{ entry['TotalReflections'] }}</span>
              </div>

              <!-- Modal Trigger -->
              <a class="content-modal-trigger" v-if="parseInt(entry[key]) === 0">
                <!-- <i class="fas fa-eye disabled-color"></i> -->
                <span class="glyphicon glyphicon-eye-open disabled-color"></span>
              </a>
              <a class="content-modal-trigger" @click.stop="performOperation($event,entry,'discussion_post')" v-else>
                <!-- <i class="fas fa-eye"></i> -->
                <div class="glyphicon glyphicon-eye-open tooltip1"><div class="tooltiptext">Click to see details</div></div>
              </a>

              <div class="progress margin-auto">
                <div :class="getStatusClasses(getPercent(entry[key], entry['TotalReflections']))" role="progressbar" :aria-valuenow="getPercent(entry[key], entry['TotalReflections'])" aria-valuemin="0" :aria-valuemax="100" :style="getStyle(getPercent(entry[key], entry['TotalReflections']))">
                  <span class="sr-only">{{ getPercent(entry[key], entry['TotalReflections']) }}% Complete (warning)</span>
                </div>
              </div>
            </div>

            <div v-else-if="key === 'ChallengesTaken'">
              <div :class="['stat-value-label', { 'danger': getPercent(entry[key], entry['TotalChallenges']) === 0 }]">
                <span class="value">{{ entry[key] }}</span>/<span class="total">{{ entry['TotalChallenges'] }}</span>
              </div>

              <!-- Modal Trigger -->
              <a class="content-modal-trigger" v-if="parseInt(entry[key]) === 0">
                <!-- <i class="fas fa-eye disabled-color"></i> -->
                <span class="glyphicon glyphicon-eye-open disabled-color"></span>
              </a>
              <a class="content-modal-trigger" @click.stop="performOperation($event,entry,'challenges_taken')" v-else>
                <!-- <i class="fas fa-eye"></i> -->
                <div class="glyphicon glyphicon-eye-open tooltip1"><div class="tooltiptext">Click to see details</div></div>
              </a>

              <div class="progress margin-auto">
                <div :class="getStatusClasses(getPercent(entry[key], entry['TotalChallenges']))" role="progressbar" :aria-valuenow="getPercent(entry[key], entry['TotalChallenges'])" aria-valuemin="0" :aria-valuemax="100" :style="getStyle(getPercent(entry[key], entry['TotalChallenges']))">
                  <span class="sr-only">{{ getPercent(entry[key], entry['TotalChallenges']) }}% Complete (warning)</span>
                </div>
              </div>
            </div>

            <div v-else-if="key === 'LastLoginTS'">
              {{ timeSince(entry['LastLoginTS']) }}
            </div>

          </td>
        </tr>
      </tbody>
      <tbody v-if="currDashboardTabSelection !== 1">
        <tr v-for="(entry, index) in filteredData" :key="index">
          <td v-for="key in columns" :key="key" class="text-align-center">
            <div v-if="key !== 'ReleaseTS'">
              {{ entry[key] }}
            </div>
            <div v-else>
              {{ formatDate(entry[key]) }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Open Discussion Post Overlay -->
    <discussion-post-report v-if="showDisscussonOverlay" @showOverlay="closeOverlay" v-bind:selectedUserProgressObj="selectedObj" v-bind:discussionResp="discussionResp"></discussion-post-report>
    <!-- Open Discussion Post Overlay -->

    <!-- Open Challenges Taken Overlay -->
    <challenges-taken-report v-if="showChallengesTakenOverlay" @showOverlay="closeOverlay" v-bind:selectedUserProgressObj="selectedObj" v-bind:challengesTakenResp="challengesTakenResp" v-bind:challengesTakenExportResp="challengesTakenExportResp"></challenges-taken-report>
    <!-- Open Challenges Taken Overlay -->

    <!-- Used to show alerts to user -->
    <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    <!-- Used to show alerts to user -->
  </div>
</template>


<script>
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { constants } from '@/utils/constants'
import DiscussionPostReport from '@/components/dashboard_v2/DiscussionPostReport'
import ChallengesTakenReport from '@/components/dashboard_v2/ChallengesTakenReport'
import { reportService } from '@/server-util/report-service'
import moment from 'moment-timezone'

export default {
  name: 'CustomDataTable',

  props: {
    data: Array,
    columns: Array,
    sortColumns: Array,
    filterKey: String,
    colsWithAlias: Array
  },

  components: {
    'discussion-post-report': DiscussionPostReport,
    'challenges-taken-report': ChallengesTakenReport,
    'alert-box': AlertBox
  },

  data () {
    if (this.data === undefined || this.data === null) {
      return
    }
    var sortOrders = {}

    this.sortColumns.forEach(function (key) {
      sortOrders[key] = 1
    })

    return {
      sortedOn: '',
      sortKey: '',
      sortOrders: sortOrders,
      statusZones: [
        {
          name: 'danger',
          min: 0,
          max: 20
        },
        {
          name: 'warning',
          min: 21,
          max: 79
        },
        {
          name: 'success',
          min: 80,
          max: 100
        }
      ],
      selectedObj: null,
      showDisscussonOverlay: false,
      showChallengesTakenOverlay: false,
      discussionResp: [],
      challengesTakenResp: [],
      showAlertDialog: false,
      errorMsg: false,
      challengesTakenExportResp: []
    }
  },

  computed: {

    currDashboardTabSelection: {
      get: function () {
        return this.$store.getters.currDashboardTabSelection
      }
    },

    filteredData: function () {
      var sortKey = this.sortKey
      var filterKey = this.filterKey && this.filterKey.toLowerCase()
      var order = this.sortOrders[sortKey] || 1
      var data = this.data
      if (filterKey) {
        data = data.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
      if (sortKey) {
        data = data.slice().sort(function (a, b) {
          a = a[sortKey]
          b = b[sortKey]
          return (a === b ? 0 : a > b ? 1 : -1) * order
        })
      }
      // console.log('::: ' + data.length)
      // AK: Allow to export particular sorted data
      this.$emit('selectedData', data)
      return data
    }
  },
  filters: {
    capitalize: function (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  },
  methods: {
    sortBy: function (key) {
      console.log('SORT KEY : ' + key)
      console.log('SORT COLUMNS : ' + this.sortColumns.indexOf(key))
      if (this.sortColumns.indexOf(key) > -1) {
        this.sortKey = key
        this.sortOrders[key] = this.sortOrders[key] * -1
      }
    },
    checkSortable: function (key) {
      return this.sortColumns.indexOf(key) > -1
    },
    titleCase (value) {
      // eslint-disable-next-line
      return _.startCase(value)
    },

    getStyle (percent) {
      return `width: ${percent}%;`
    },

    getPercent (val1, val2) {
      /* eslint-disable */
      val1 = _.round(_.parseInt(val1))
      val2 = _.round(_.parseInt(val2))

      if (val1 && val2 && val2 !== 0 && typeof val1 !== 'undefined' && typeof val2 !== 'undefined') {
        return _.round((val1 / val2) * 100)
      } else {
        return 0
      }
      /* eslint-enable */
    },

    getStatusClasses (percent) {
      /* eslint-disable */
      let applicableZone = _.filter(this.statusZones, zone => {
        return (percent >= zone.min && percent <= zone.max)
      })[0]

      if (_.isArray(applicableZone)) {
        return `progress-bar`
      } else if (applicableZone) {
        return `progress-bar progress-bar-${applicableZone.name}`
      }
      /* eslint-enable */
    },

    refresh () {
      // eslint-disable-next-line
      this.init()
    },

    sort (colName) {
      if (this.sortedOn === colName) {
        switch (this.sortOrder) {
          case 'asc':
            this.sortOrder = 'desc'
            break

          default:
            this.sortOrder = 'asc'
            break
        }
      } else {
        this.sortedOn = colName
        this.sortOrder = 'asc'
      }

      this.$forceUpdate()
    },

    timeSince (dateString) {
      /* eslint-disable */
      if (!_.includes(dateString, '01/01/0001')) {
        return moment.tz(dateString, 'MM/DD/YYYY hh:mm:ss tt', 'America/New_York').fromNow()
      } else {
        return 'NO LOGIN'
      }
      /* eslint-enable */
    },

    formatDate (dateString) {
      /* eslint-disable */
      if (!_.includes(dateString, '01/01/0001') && !_.includes(dateString, 'NA')) {
        return dmAdminUtils.getHumanReadableDate(dateString)
      } else {
        return 'NA'
      }
      /* eslint-enable */
    },

    performOperation ($event, selectedObj, selectedOperation) {
      // AK: Assign selected Obj
      this.selectedObj = selectedObj
      switch (selectedOperation) {
        case 'challenges_taken':
          this.getChallengesTaken()
          break
        case 'discussion_post':
          this.getDiscussionPost()
          break
      }
    },

    closeOverlay (value) {
      // AK: When user pressed close selected Challenges Taken or Discussion overlay
      this.showDisscussonOverlay = value
      this.showChallengesTakenOverlay = value
      this.$store.state.isOverlayVisible = value
    },

    getDiscussionPost: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedObj.UserCourseId !== null || this.selectedObj.UserCourseId !== undefined || this.selectedObj.UserCourseId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getDiscussionPosts(storeObj.state.access_token, _this.selectedObj.UserCourseId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recievinglist
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.discussionResp = responseObj.data
              // console.log(JSON.stringify(_this.discussionResp))
              _this.showDisscussonOverlay = true
              _this.$store.state.isOverlayVisible = true
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('UserCourseId ID is NULL hence declined LOADING Discussion Post')
      }
    },

    getChallengesTaken: function () {
      var storeObj = this.$store
      var _this = this
      if (this.selectedObj.UserCourseId !== null || this.selectedObj.UserCourseId !== undefined || this.selectedObj.UserCourseId !== '') {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        reportService.getChallengesTaken(storeObj.state.access_token, _this.selectedObj.UserCourseId).then(
          responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              _this.challengesTakenResp = responseObj.data
              _this.bindTLQRespForExport()
            } else {
              // AK: Hide Spinner
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg =
                'Oops! Something went wrong. Please try again.'
            }
          },
          errorObj => {
            // AK: Hide Spinner
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          }
        )
      } else {
        console.log('UserCourseId ID is NULL hence declined LOADING Challenges Taken.')
      }
    },
    bindTLQResp: function () {
      this.tempChallengesTakenResp = []
      for (var i = 0; i < this.challengesTakenResp.length; i++) {
        var obj = {
          ChallengeTitle: this.challengesTakenResp[i].ChallengeTitle,
          ResponseVideoUrl: this.challengesTakenResp[i].ResponseVideoUrl,
          ResponseText: this.challengesTakenResp[i].ResponseText,
          ResponseAudioUrl: this.challengesTakenResp[i].ResponseAudioUrl,
          FeedbackScore1: this.challengesTakenResp[i].FeedbackScore1,
          FeedbackScore2: this.challengesTakenResp[i].FeedbackScore2,
          FeedbackScore3: this.challengesTakenResp[i].FeedbackScore3,
          AverageP2PScore: this.challengesTakenResp[i].AverageP2PScore,
          AverageScore: '', // this.challengesTakenResp[i].AverageScore,
          FeedbackReceived: this.challengesTakenResp[i].FeedbackReceived,
          FeedbackGiven: this.challengesTakenResp[i].FeedbackGiven,
          FeedbackReviewed: this.challengesTakenResp[i].FeedbackReviewed,
          ChallengeType: this.challengesTakenResp[i].ChallengeType,
          MaxPeers: this.challengesTakenResp[i].MaxPeers,
          TrafficLightScore: '',
          OverallP2PScore: '' // this.challengesTakenResp[i].FeedbackScore1 + ' ' + this.challengesTakenResp[i].FeedbackScore2 + ' ' + this.challengesTakenResp[i].FeedbackScore3
        }
        for (var j = 0; j < this.challengesTakenResp[i].TrafficLightScore.length; j++) {
          obj.TrafficLightScore += '<span><b>' + this.challengesTakenResp[i].TrafficLightScore[j].Technique + ':</b>  <br/>'
          for (var kk = 0; kk < 3; kk++) {
            var selectedValue = this.challengesTakenResp[i].TrafficLightScore[j].Scores[kk]
            switch (selectedValue) {
              case 'G':
                obj.TrafficLightScore += '<button style=\'col-lg-2 width: 5px; height: 15px; border-radius: 50%;background-color: #54a865; cursor: default;\'></button>&nbsp;'
                break
              case 'Y':
                obj.TrafficLightScore += '<button style=\'col-lg-2 width: 5px; height: 15px; border-radius: 50%;background-color: #ecc046; cursor: default;\'></button>&nbsp;'
                break
              case 'R':
                obj.TrafficLightScore += '<button style=\'col-lg-2 width: 5px; height: 15px; border-radius: 50%;background-color: #dd0b0b; cursor: default;\'></button>'
                break
            }
          }
          obj.TrafficLightScore += '</span><br/> '
          obj.AverageScore += '<span>' + this.challengesTakenResp[i].TrafficLightScore[j].AvgScore + '</span><br/></br/>'
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === 1) {
          obj.OverallP2PScore += this.challengesTakenResp[i].FeedbackScore1 + '&nbsp;<span class=\'glyphicon glyphicon-remove\'></span>&nbsp;<span class=\'glyphicon glyphicon-remove\'></span>'
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === 2) {
          obj.OverallP2PScore += this.challengesTakenResp[i].FeedbackScore1 + '&nbsp;' + this.challengesTakenResp[i].FeedbackScore2 + '&nbsp;<span class=\'glyphicon glyphicon-remove\'></span>'
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === 3) {
          obj.OverallP2PScore += this.challengesTakenResp[i].FeedbackScore1 + '&nbsp;' + this.challengesTakenResp[i].FeedbackScore2 + '&nbsp;' + this.challengesTakenResp[i].FeedbackScore3
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === -1 || parseInt(this.challengesTakenResp[i].MaxPeers) === -100) {
          obj.OverallP2PScore += '<span class=\'glyphicon glyphicon-remove\'></span>&nbsp;<span class=\'glyphicon glyphicon-remove\'></span>&nbsp;<span class=\'glyphicon glyphicon-remove\'></span>'
        }
        this.tempChallengesTakenResp.push(obj)
      }
      this.challengesTakenResp = this.tempChallengesTakenResp
      // console.log('this.challengesTakenResp >>> ' + JSON.stringify(this.challengesTakenResp))
      this.showChallengesTakenOverlay = true
      this.$store.state.isOverlayVisible = true
    },

    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },

    bindTLQRespForExport: function () {
      var tempChallengesTakenResp = []
      this.challengesTakenResp.forEach((obj) => {
        if (parseInt(obj.ResponseType) === parseInt(constants.ResponseType.Audio)) {
          obj.ResponseAudioUrl = obj.ResponseVideoUrl
          obj.ResponseVideoUrl = null
        } else if (parseInt(obj.ResponseType) === parseInt(constants.ResponseType.Text)) {
          obj.ResponseAudioUrl = null
          obj.ResponseVideoUrl = null
        } else {
          obj.ResponseAudioUrl = null
          obj.ResponseVideoUrl = obj.ResponseVideoUrl
        }
      })
      for (var i = 0; i < this.challengesTakenResp.length; i++) {
        var obj = {
          ChallengeTitle: this.challengesTakenResp[i].ChallengeTitle,
          ResponseVideoUrl: this.challengesTakenResp[i].ResponseVideoUrl,
          ResponseText: this.challengesTakenResp[i].ResponseText,
          ResponseAudioUrl: this.challengesTakenResp[i].ResponseAudioUrl,
          FeedbackScore1: this.challengesTakenResp[i].FeedbackScore1,
          FeedbackScore2: this.challengesTakenResp[i].FeedbackScore2,
          FeedbackScore3: this.challengesTakenResp[i].FeedbackScore3,
          AverageP2PScore: this.challengesTakenResp[i].AverageP2PScore,
          AverageScore: '', // this.challengesTakenResp[i].AverageScore,
          FeedbackReceived: this.challengesTakenResp[i].FeedbackReceived,
          FeedbackGiven: this.challengesTakenResp[i].FeedbackGiven,
          FeedbackReviewed: this.challengesTakenResp[i].FeedbackReviewed,
          ChallengeType: this.challengesTakenResp[i].ChallengeType,
          MaxPeers: this.challengesTakenResp[i].MaxPeers,
          TrafficLightScore: '',
          OverallP2PScore: '' // this.challengesTakenResp[i].FeedbackScore1 + ' ' + this.challengesTakenResp[i].FeedbackScore2 + ' ' + this.challengesTakenResp[i].FeedbackScore3
        }
        for (var j = 0; j < this.challengesTakenResp[i].TrafficLightScore.length; j++) {
          obj.TrafficLightScore += '' + this.challengesTakenResp[i].TrafficLightScore[j].Technique + ': '
          for (var kk = 0; kk < 3; kk++) {
            var selectedValue = this.challengesTakenResp[i].TrafficLightScore[j].Scores[kk]
            switch (selectedValue) {
              case 'G':
                obj.TrafficLightScore += 'G '
                break
              case 'Y':
                obj.TrafficLightScore += 'Y '
                break
              case 'R':
                obj.TrafficLightScore += 'R'
                break
            }
          }
          obj.AverageScore += this.challengesTakenResp[i].TrafficLightScore[j].AvgScore + ' '
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === 1) {
          obj.OverallP2PScore += this.challengesTakenResp[i].FeedbackScore1 + 'X X'
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === 2) {
          obj.OverallP2PScore += this.challengesTakenResp[i].FeedbackScore1 + ' ' + this.challengesTakenResp[i].FeedbackScore2 + ' X'
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === 3) {
          obj.OverallP2PScore += this.challengesTakenResp[i].FeedbackScore1 + ' ' + this.challengesTakenResp[i].FeedbackScore2 + ' ' + this.challengesTakenResp[i].FeedbackScore3
        }
        if (parseInt(this.challengesTakenResp[i].MaxPeers) === -1 || parseInt(this.challengesTakenResp[i].MaxPeers) === -100) {
          obj.OverallP2PScore += 'X X X'
        }
        tempChallengesTakenResp.push(obj)
      }
      this.challengesTakenExportResp = tempChallengesTakenResp
      this.bindTLQResp()
    }
  }
}
</script>


<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,400i,600');

  .data-table-container {
    margin: 1em;
    padding: 1em 0;
    border-top: 0px solid #ebebeb;
    border-bottom: 0px solid #ebebeb;
  }

  .data-table-container .table {
    td, th {
      font-family: 'Source Sans Pro', 'Avenir', 'Helvetica', sans-serif;
      font-size: 14px;
      color: #27345B;
    }

    th button {
      background-color: transparent;
      border: none;
      outline: none;
      padding: 0;
    }

    td {
      font-weight: 400;
    }

    th {
      font-weight: 600;
    }

    .table-controls {
      display: none;
    }
  }

  .data-table-container .progress {
    width: 70px;
    min-width: 70px;
    max-width: 70px;
    height: 7px;
    min-height: 7px;
    max-height: 7px;
    margin-bottom: 6px;
    box-shadow: none;
    -webkit-box-shadow: none;
    background-color: #ebebeb;
  }

  .data-table-container .progress-bar {
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .data-table-container .stat-value-label {
    display: inline-block;
    font-size: 1em;

    .value, .total {
      font-weight: bold;
    }

    .total {
      font-size: 0.8em !important;
    }
  }

  .data-table-container .stat-value-label.danger {
    color: #d9534f;
  }

  .data-table-container .pagination li a {
    background-color: #ebebeb;
    border: 1px solid white;
    color: #27345B;
  }

  .data-table-container .pagination li.active a {
    background-color: #27345B;
    color: white;
  }

  .records-per-page {
    width: 300px;
    float: right;
    margin: 0 auto;
    text-align: right;

    select {
      display: inline-block;
      width: 60px;
      margin: 0 0.33em;
    }
  }

  .search-field {
    float: left;
    width: 200px;
  }

  .table-controls {
    border-bottom: 1px solid #ebebeb;
    height: 45px;
  }

  .sort-key {
    border-bottom: 2px solid #27345B !important;
  }

  .content-modal-trigger {
    color: #27345B;
    margin-left: 2em;
    cursor: pointer;
    font-size: 0.8em;
    z-index: 10000;
  }

  .content-modal-trigger:hover,
  .content-modal-trigger:focus,
  .content-modal-trigger:active {
    color: #F5731C;
  }

  .modal-content {
    border-radius: 0;
  }

  .disabled-color{
    color: #aaaaaa !important;
    cursor: default !important;
  }

  .arrow {
    display: inline-block;
    vertical-align: middle;
    width: 0;
    height: 0;
    margin-left: 5px;
    opacity: 0.66;
  }

  .arrow.asc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: 4px solid #000;
  }

  .arrow.dsc {
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 4px solid #000;
  }

  .arrow.none{
    display: none;
  }
.tooltip1 {
    position: relative;
    display: inline-block;
    // border-bottom: 1px dotted black;
}
.tooltip1 .tooltiptext {
    visibility: hidden;
    width: 50px;
    background-color: #696969;;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 100%;
    left: 50%;
    margin-left: 4px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 12px;
    }
.tooltip1:hover .tooltiptext {
    visibility: visible;
}
.opacity-point-5 {
  opacity: 0.5;
}
.table > tbody > tr > td {
  vertical-align: middle;
  border: 0.5px solid #ebebeb;
}
.table > thead > tr > th {
  vertical-align: middle;
  border: 0.5px solid #ebebeb;
}
.text-align-center {
  text-align: center;
}
.margin-auto {
  margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard_v2/CustomDataTable.vue